// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1mtn2","header":"Messages_header__39j01"};